type Option = { key: string; label: string };

type FilterRowProps = {
  label: string;
  options: Option[];
  value: string;
  onChange: (value: string) => void;
};

export default function FilterRow({ label, options, value, onChange }: FilterRowProps) {
  return (
    <div className="flex flex-col gap-2 py-3 md:flex-row md:items-center md:gap-4">
      <span className="shrink-0 text-xs font-medium text-foreground-500 md:w-16 md:text-sm">{label}</span>
      <div className="flex flex-wrap gap-1.5 md:gap-2">
        {options.map((option) => {
          const active = option.key === value;
          return (
            <button
              key={option.key}
              type="button"
              aria-pressed={active}
              onClick={() => onChange(option.key)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-xs transition-colors md:text-sm ${
                active
                  ? "bg-primary-500 font-medium text-background-950"
                  : "border border-foreground-50/10 text-foreground-400 hover:border-primary-400/50 hover:text-primary-300"
              }`}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}